export function getCleanCategoryObj(categoryObj) {
  const cleanObj = {};
  Object.keys(categoryObj).forEach((key) => {
    if (categoryObj[key]) {
      cleanObj[key] = categoryObj[key];
    }
  });
  return cleanObj;
}
